/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import wrapRoot from './wrap-root-element';
import './src/components/CodeBlock/prism-ambassador.css';

export const onRouteUpdate = state => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'virtualPageView',
    page: {
      url: state.location.pathname,
    },
  });
};

export const wrapRootElement = wrapRoot;